import { Component, inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { CommonModule, Location } from '@angular/common'
import { AbstractComponent } from '@monorepo-channels/channels/domain'
import { MatIconModule } from '@angular/material/icon'
import { DataLayerService } from '@monorepo-channels/shared/util-helpers'

@Component({
	standalone: true,
	selector: 'porto-bank-terms-of-use',
	imports: [MatButtonModule, CommonModule, MatIconModule],
	styleUrl: './terms-and-conditions.component.scss',
	template: `
		<main class="container">
			<button (click)="this.location.back()" class="back-button">
				<mat-icon svgIcon="porto-bank-icons:left-arrow"></mat-icon>
				Voltar
			</button>

			<div class="container__content">
				<h1 class="title">Termos de Uso</h1>

				<p class="content">
					Para usufruir do benefício, é necessário fazer um check-in ou uma reserva. Ao chegar no
					restaurante, mencione que a reserva ou check-in foi feito pelo Gastronomia Porto Bank. O
					pagamento deverá ser feito exclusivamente com o cartão de crédito Porto Bank. Cabe
					ressaltar que o check-in, diferentemente da reserva, não garante uma mesa para o
					participante. O cliente tem direito a realizar um reserva ou check in por dia.
				</p>

				<br />
				<p class="content">
					Os diferenciais podem variar de acordo com cada restaurante, são válidos apenas nas
					unidades indicadas no site e não são cumulativos com outras promoções.
				</p>

				<br />
				<p class="content">
					Participam do Gastronomia Porto Bank os cartões de crédito emitidos pelo Porto Bank nas
					bandeiras Visa e Mastercard®: Porto Bank Mastercard® Black, Porto Bank Visa Infinite,
					Porto Bank Visa Platinum, Porto Bank Mastercard® Platinum, Porto Bank Visa Gold, Porto
					Bank Mastercard® Gold, Porto Bank Empresarial Visa Platinum, Porto Bank Empresarial
					Mastercard® Platinum
				</p>

				<br />
				<p class="content">
					As reservas estão sujeitas a disponibilidade do restaurante. O Porto Bank não se
					responsabiliza por serviços prestados por terceiros. O benefício pode ser cancelado a
					qualquer momento, sem aviso prévio.
				</p>
			</div>
			<div style="height: 120px"></div>
		</main>
	`,
})
export class TermsOfUsePageComponent extends AbstractComponent implements OnInit {
	public location = inject(Location)
	private dataLayerService = inject(DataLayerService)

	ngOnInit(): void {
		this.dataLayerService.logEvent({
			event: 'screen_view',
			screen_name: 'Gastronomia Porto Bank - Termos e condições',
		})
	}
}
